module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div tabindex="0" class="apexchat_overlay_content" id="opt_in_consent">\r\n    <div class="apexchat_consent_header">\r\n        <div class="apexchat_consent_title">\r\n            ' +
((__t = (text )) == null ? '' : __t) +
'\r\n        </div>\r\n    </div>\r\n    <div class="apexchat_consent_main_content">\r\n        <div class="apexchat_consent_action">\r\n            ';
 if (acceptText) { ;
__p += '\r\n                <div class="livechat_btn livechat_btn_less_round">\r\n                    <button class="livechat_optin_agree livechat_btn_item apexchat_btn_item">\r\n                        ' +
((__t = ( acceptText )) == null ? '' : __t) +
'\r\n                    </button>\r\n                </div>\r\n                ';
 } ;
__p += '\r\n                    ';
 if (changeText) { ;
__p += '\r\n                        <div class="livechat_btn livechat_btn_less_round">\r\n                            <button class="livechat_optin_change livechat_btn_item apexchat_btn_item">\r\n                                ' +
((__t = ( changeText )) == null ? '' : __t) +
'\r\n                            </button>\r\n                        </div>\r\n                        ';
 } ;
__p += '\r\n                            ';
 if (rejectText) { ;
__p += '\r\n                                <div class="livechat_btn livechat_btn_less_round">\r\n\r\n                                    <button class="livechat_optout livechat_btn_item livechat_btn_item_gray">\r\n                                        ' +
((__t = ( rejectText )) == null ? '' : __t) +
'\r\n                                    </button>\r\n                                </div>\r\n                                ';
 } ;
__p += '\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}